module.exports = __webpack_public_path__ + "static/media/update_white_24dp.0edfc144.svg";